import React, { useState, useEffect } from "react";
// import { Counter } from './features/counter/Counter';
// import Navbar from "./HHC/Navbar";
// import Footer from "./HHC/Footer";
// import Header from "./HHC/Header";
import NotFound from "./HHC/NotFound";
import "./App.css";
import { BrowserRouter, Router, Routes, Route } from "react-router-dom";
import Viewservice from "./HHC/components/HD/Viewservice";
import UserDetails from "./HHC/components/UserDeatilsForm/UserDetails";
import Loginextentions from "./HHC/components/Login/Loginextentions";
import Dashboard from "./HHC/components/HD/Dashboard/Dashboard";
import Addservice from "./HHC/components/HD/Addservice";
import Ongoingservice from "./HHC/components/HD/Ongoingservice/Ongoingservice";
import Professional from "./HHC/components/HD/Dashboard/Professional";
import ServiceRequest from "./HHC/components/HD/Servicerequest/ServiceRequest";
import Enquiries from "./HHC/components/HD/Enquiries/Enquiries";
import Schedule from "./HHC/components/HD/Professional/Schedule";
import Membership from "./HHC/components/HD/Membership/Membership";
import ManageProfile from "./HHC/components/HR/Profile/ManageProfile";
import AddProfessional from "./HHC/components/HR/Profile/AddProfessional";
import Interview from "./HHC/components/HR/Interview/Interview";
import Candidates from "./HHC/components/HR/Onboarding/Candidates";
import Employee from "./HHC/components/HR/Employee/Employee";
import ConsentDetails from "./HHC/components/HD/Viewservice/ConsentForm/ConsentDetails";
import HRDashboard from "./HHC/components/HR/Dashboard/HRDashboard";
import Attendence from "./HHC/components/HR/Attendence/Attendence";
import Permission from "./HHC/components/ADMIN/Permission";
import AdminDashboard from "./HHC/components/ADMIN/AdminDashboard";
import AdminReport from "./HHC/components/ADMIN/Reports/AdminReport";
import EnquiryReport from "./HHC/components/ADMIN/Reports/EnquiryReport";
import ConsultantReport from "./HHC/components/ADMIN/Reports/ConsultantReport";
import HospitalReport from "./HHC/components/ADMIN/Reports/HospitalReport";
import MonthlyReport from "./HHC/components/ADMIN/Reports/MonthlyReport";
import PaymentCancellation from "./HHC/components/ADMIN/Reports/PaymentCancellation";
import RefundAmount from "./HHC/components/ADMIN/Reports/RefundAmount";
import JobClosure from "./HHC/components/ADMIN/Reports/JonClosure";
import ConsentForm from "./HHC/components/ADMIN/Reports/ConsentForm";
import ManageService from "./HHC/components/ADMIN/HCM/ManageService";
import ManageHospital from "./HHC/components/ADMIN/HCM/ManageHospital";
import ManageFeedBack from "./HHC/components/ADMIN/HCM/ManageFeedBack";
import ManagePayment from "./HHC/components/ADMIN/HCM/ManagePayment";
import NewExportReceipt from "./HHC/components/ADMIN/ACCOUNT/NewExportReceipt";
import ExportInvoice from "./HHC/components/ADMIN/ACCOUNT/ExportInvoice";
import PaymentWithProfessional from "./HHC/components/ADMIN/ACCOUNT/PaymentWithProfessional";
import PaymentPatient from "./HHC/components/ADMIN/ACCOUNT/PaymentPatient";
import Cashfree from "./HHC/components/ADMIN/ACCOUNT/Cashfree";
import PendingPayment from "./HHC/components/ADMIN/ACCOUNT/PendingPayment";
import DayPrintBHV from "./HHC/components/ADMIN/ACCOUNT/DayPrintBHV";
import JobClosureAccount from "./HHC/components/ADMIN/ACCOUNT/JobClosureAccount";
import ProfessionalUnit from "./HHC/components/ADMIN/ACCOUNT/ProfessionalUnit";
import ProfRequest from "./HHC/components/HD/ProfRequest/ProfRequest";
import AccountDashboard from "./HHC/components/ADMIN/ACCOUNT/AccountDashboard";
import LoginEmployees from "./HHC/components/ADMIN/HCM/LoginEmployees";
import OnlineTransaction from "./HHC/components/ADMIN/ACCOUNT/OnlineTransaction";
import DemoPurpose from "./HHC/components/ADMIN/DemoPurpose";
import HospitalDashboard from "./HHC/components/Hospitals/Dashboard/HospitalDashboard";
import AllocatedList from "./HHC/components/ADMIN/HCM/ProfessionalAllocation/AllocatedList";
import PaymentUTR from "./HHC/components/ADMIN/ACCOUNT/PaymentUTR";
import ManageAttendance from "./HHC/components/Attendance/ManageAttendance";
import AtteDashboard from "./HHC/components/Attendance/AtteDashboard";
import ManagementDashboard from "./HHC/components/ManagementDashboard/MDashboard";
import ManageReports from "./HHC/components/Attendance/ManageReports";
import ProfessionalDetails from "./HHC/components/ADMIN/HCM/ProfessionalDetails";
import SystemUser from "./HHC/components/HR/SystemUser/SystemUser";
import Header from "./HHC/components/Clinical/Header";
// import ManageInventory from "./HHC/components/InventoryModule/ManageInventory";
import HrDashboard from "./HHC/components/HrPartner/Dashboard/HrDashboard";
import ManageProfessionals from "./HHC/components/HrPartner/Professionals/ManageProfessionals";
import AddProfPartner from "./HHC/components/HrPartner/Professionals/AddProfPartner";
import ExternalProf from "./HHC/components/HR/ExternalProfessional/ExternalProf";
import Servicedetails from "./HHC/components/HrPartner/ServiceDetails/Servicedetails";
import Home from "./HHC/components/HHC_Analytics/Home";
import { Insurance } from "./HHC/components/ADMIN/HCM/Insurance/Insurance";
import ClosureRevalidation from "./HHC/components/ADMIN/HCM/ClosureRevalidation/ClosureRevalidation";
// import Telemedicine from "./HHC/components/Clinical/ClinicalComponents/Telemedicine";
import ClosureDetails from "./HHC/components/Clinical/ClosureDetails";
import MM2Dashboard from "./HHC/components/M2Dashboard/MM2Dashboard";
import ConsultantList from "./HHC/components/ADMIN/HCM/Consultant/ConsultantList";
import Clinicalgov from "./HHC/components/ADMIN/ClinicalNew/Clinicalgov";
import Refund from "./HHC/components/ADMIN/Refund/Refund";
import PhysioMiles from "./HHC/components/ADMIN/PhysioMilestone/PhysioMiles";
import ManageConsultant from "./HHC/components/ADMIN/HCM/Manage Consultant/ManageConsultant";
import ConsultantLogin from "./HHC/components/Consultant/ConsultantLogin/ConsultantLogin";

// import Physio from "./HHC/components/Physio/Physio";
import SupervisorVisitor from "./HHC/components/ADMIN/Supervisorvistior/SupervisorVisitor";

import AddPhysioMiles from "./HHC/components/ADMIN/PhysioMilestone/AddPhysioMiles";
import CareCoordinator from "./HHC/components/HR/CareTaker/CareTaker";
import Patientblacklist from "./HHC/components/ADMIN/HCM/Patientblacklist";
import ClinicalReports from "./HHC/components/ADMIN/Reports/ClinicalReports";
import RefundReports from "./HHC/components/ADMIN/Reports/RefunReports";
import PatientFeedbackReport from "./HHC/components/ADMIN/Reports/Patientfeedback/PatientFeedbackReport";
import ProfessionalFeedbackReport from "./HHC/components/ADMIN/Reports/ProfessionalFeedbackReport";
import HD_Dashboard from "./HHC/components/HD/HD_Dashboard/HD_Dashboard";
// import LongTearmForm from "./HHC/components/ADMIN/HCM/LongtermForm/LongtermForm";
// import MedicalForm from "./HHC/components/ADMIN/HCM/LongtermForm/MedicalForm";
import ShiftHandover from "./HHC/components/HD/ShiftHandover/ShiftHandover";
import TermsCondition from "./HHC/components/PrivacyPolicy/TermsCondition";
import CancellationRefundPolicy from "./HHC/components/PrivacyPolicy/CancellationRefundPolicy";
import ContactInfo from "./HHC/components/PrivacyPolicy/ContactInfo";
import AboutUs from "./HHC/components/PrivacyPolicy/AboutUs";
import LongTearmForm from "./HHC/components/ADMIN/HCM/LongtermForm/LongtermForm";
import ReferredPatientDetails from "./HHC/components/Consultant/ConsultantForm/ReferredPatientDetails";
import ReferredPatient from "./HHC/components/Consultant/ConsultantForm/ReferredPatient";
import ShiftHandoverReport from "./HHC/components/ADMIN/Reports/ShiftHandOverReport";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Box, Typography, Paper } from "@mui/material";
import MedicalForm from "./HHC/components/ADMIN/HCM/LongtermForm/MedicalForm";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import { API_URL } from "./HHC/components/Config/api";
import LongTermReport from "./HHC/components/ADMIN/Reports/LongTermReport/LongTermReport";
import ProfRequestPayout from "./HHC/components/ADMIN/PaymentPayout/ProfRequestPayout/ProfRequestPayout";
import ProcessPayout from "./HHC/components/ADMIN/PaymentPayout/ProcessPayout/ProcessPayout";
import ApprovedPayoutList from "./HHC/components/ADMIN/PaymentPayout/ApprovedPayoutList/ApprovedPayoutList";
import PaymentpayoutReport from "./HHC/components/ADMIN/PaymentPayout/Report/PaymentpayoutReport";
import CallModal from "./HHC/components/Callmodal/CallModal";


function App() {
  // const port = process.env.REACT_APP_API_KEY;

  const [isLoggIn, setIsLoggIn] = useState(
    localStorage.getItem("user_group")
      ? localStorage.getItem("user_group") === "true"
      : false
  );

  useEffect(() => {
    const userGroup = localStorage.getItem("user_group");
    setIsLoggIn(userGroup === "hr");
  }, []);
  const [linkStatus, setLinkStatus] = useState("loading"); // "loading" | "valid" | "expired" | "notFound" | "error"

  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const checkServiceStatus = async (id) => {
    try {
      const response = await fetch(`${API_URL}/web/is_service_cancelled/${ id}/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response:", data);

      if (data.message === "form already submitted") {
        setLinkExpired("submitted"); // new case
      } else if (data.status === "Does not exist") {
        setLinkExpired("notFound");
      } else if (data.status === true) {
        setLinkExpired(false); // show form
      } else {
        setLinkExpired(true); // link expired
      }
    } catch (error) {
      console.error("Error hitting API:", error);
      setLinkExpired(true);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("event_id");
    console.log("Extracted Event ID:", id);

    if (id) {
      console.log(id,"iddd");
      
      setEventID(id);
      checkServiceStatus(id);
    } else {
      setLinkStatus("notFound");
    }
  }, []);

  const [eventID, setEventID] = useState(null);
  console.log(eventID,"eventidjsss");
  

  const [linkExpired, setLinkExpired] = useState(false);
  console.log(linkExpired, "linkExpiredlinkExpired");

  useEffect(() => {
    setLinkExpired(false);
  }, []);

  return (
    <div className="App">
      <BrowserRouter basename="">
      <CallModal />
        <div>
          {/* {isLoggIn && <HRNavbar />} */}
          {/* {isLoggIn && <HRHeader />} */}
          <Routes>
            <Route exact path="/" element={<Loginextentions />} />
            {/* HD Module */}
            <Route
              exact
              path="/dashboard"
              element={isLoggedIn ? <HD_Dashboard /> : <Loginextentions />}
            />

            <Route
              exact
              path="/consultantLogin"
              element={isLoggedIn ? <ConsultantLogin /> : <ConsultantLogin />}
            />
            {/* <Route exact path="/MM2Dashboard" element={isLoggedIn ? <MM2Dashboard /> : <Login />} /> */}
            <Route
              exact
              path="/addservice"
              element={isLoggedIn ? <Addservice /> : <Loginextentions />}
            />
            <Route
              exact
              path="/viewservice"
              element={isLoggedIn ? <Viewservice /> : <Loginextentions />}
            />
            <Route
              exact
              path="/ongoing"
              element={isLoggedIn ? <Ongoingservice /> : <Loginextentions />}
            />
            <Route
              exact
              path="/professional"
              element={isLoggedIn ? <Schedule /> : <Loginextentions />}
            />
            <Route
              exact
              path="/service-request"
              element={isLoggedIn ? <ServiceRequest /> : <Loginextentions />}
            />
            <Route
              exact
              path="/enquiries"
              element={isLoggedIn ? <Enquiries /> : <Loginextentions />}
            />
            <Route
              path="/prof-req"
              element={isLoggedIn ? <ProfRequest /> : <Loginextentions />}
            />
            <Route
              path="/shift-handover"
              element={isLoggedIn ? <ShiftHandover /> : <Loginextentions />}
            />
            <Route
              exact
              path="/membership"
              element={isLoggedIn ? <Membership /> : <Loginextentions />}
            />
            <Route path="/hhc/user" element={<UserDetails />} />
            {/* <Route path="/consent/:eve_id/" element={<ConsentDetails />} /> */}
            <Route path="/consent" element={<ConsentDetails />} />
            {/* ADMIN Module/ */}
            <Route path="/hhc/dashboard" element={<AdminDashboard />} />
            <Route path="/hhc/permission" element={<Permission />} />
            {/* ADMIN REPORT Module/ */}
            <Route path="/hhc/reports" element={<AdminReport />} />
            <Route
              path="/hhc/reports/enquiry report"
              element={<EnquiryReport />}
            />
            <Route
              path="/hhc/reports/consultant report"
              element={<ConsultantReport />}
            />
            <Route
              path="/hhc/reports/hospital report"
              element={<HospitalReport />}
            />
            <Route
              path="/hhc/reports/monthly report"
              element={<MonthlyReport />}
            />
            <Route
              path="/hhc/reports/payment cancellation report"
              element={<PaymentCancellation />}
            />
            <Route
              path="/hhc/reports/refund amount report"
              element={<RefundAmount />}
            />
            <Route
              path="/hhc/reports/job closure report"
              element={<JobClosure />}
            />
            <Route
              path="/hhc/reports/consent form report"
              element={<ConsentForm />}
            />
            <Route
              path="/hhc/reports/Refund Report"
              element={<RefundReports />}
            />
            <Route
              path="/hhc/reports/Clinical Governance Report"
              element={<ClinicalReports />}
            />
            <Route
              path="/hhc/reports/Patient feedback report"
              element={<PatientFeedbackReport />}
            ></Route>
            <Route
              path="/hhc/reports/Professional feedback report"
              element={<ProfessionalFeedbackReport />}
            ></Route>

            <Route
              path="/hhc/reports/Long Term Report"
              element={<LongTermReport />}
            ></Route>

            {/* ADMIN HCM Module/ */}
            <Route path="/hhc/HCM/manage service" element={<ManageService />} />
            <Route
              path="/hhc/hcm/patient blacklist"
              element={<Patientblacklist />}
            />
            <Route
              path="/hhc/HCM/manage hospital"
              element={<ManageHospital />}
            />
            <Route
              path="/hhc/HCM/manage feedback"
              element={<ManageFeedBack />}
            />
            <Route
              path="/hhc/HCM/manage payment cancellations"
              element={<ManagePayment />}
            />
            <Route
              path="/hhc/HCM/login employee"
              element={<LoginEmployees />}
            />
            <Route
              path="/hhc/HCM/professional allocation"
              element={<AllocatedList />}
            />
            <Route
              path="/hhc/HCM/professional details"
              element={<ProfessionalDetails />}
            />
            <Route path="/hhc/HCM/insurance" element={<Insurance />} />
            <Route
              path="/hhc/HCM/closure revalidation"
              element={<ClosureRevalidation />}
            />
            <Route
              path="/hhc/HCM/consultant management"
              element={<ConsultantList />}
            />
            {/* ACCOUNT Routing */}
            <Route
              path="/hhc/account/dashboard"
              element={<AccountDashboard />}
            />
            <Route
              path="/hhc/account/new export receipt"
              element={<NewExportReceipt />}
            />
            <Route
              path="/hhc/account/export invoice"
              element={<ExportInvoice />}
            />
            <Route
              path="/hhc/account/payment with professional"
              element={<PaymentWithProfessional />}
            />
            <Route
              path="/hhc/account/payment with patient"
              element={<PaymentPatient />}
            />
            <Route
              path="/hhc/account/manage cashfree payment"
              element={<Cashfree />}
            />
            <Route
              path="/hhc/HCM/manage consultant"
              element={<ManageConsultant />}
            />
            <Route
              path="/hhc/account/pending payment"
              element={<PendingPayment />}
            />
            <Route path="/hhc/account/day print" element={<DayPrintBHV />} />
            <Route
              path="/hhc/account/job closure report"
              element={<JobClosureAccount />}
            />
            <Route
              path="/hhc/account/professional unit calculation"
              element={<ProfessionalUnit />}
            />
            <Route
              path="/hhc/account/online transaction"
              element={<OnlineTransaction />}
            />
            <Route path="/hhc/account/payment utr" element={<PaymentUTR />} />
            <Route path="/account/dashboard" element={<AccountDashboard />} />
            <Route
              path="/account/new export receipt"
              element={<NewExportReceipt />}
            />
            <Route path="/account/export invoice" element={<ExportInvoice />} />
            <Route
              path="/account/payment with professional"
              element={<PaymentWithProfessional />}
            />
            <Route
              path="/account/payment with patient"
              element={<PaymentPatient />}
            />
            <Route
              path="/account/manage cashfree payment"
              element={<Cashfree />}
            />
            <Route
              path="/account/pending payment"
              element={<PendingPayment />}
            />
            <Route path="/account/day print" element={<DayPrintBHV />} />
            <Route
              path="/account/job closure report"
              element={<JobClosureAccount />}
            />
            <Route
              path="/account/professional unit calculation"
              element={<ProfessionalUnit />}
            />
            <Route
              path="/account/online transaction"
              element={<OnlineTransaction />}
            />
            <Route path="/account/payment utr" element={<PaymentUTR />} />
            {/* HR Module */}
            <Route path="/hr/dashboard" element={<HRDashboard />} />
            <Route path="/hr/manage profiles" element={<ManageProfile />} />
            <Route
              path="/hr/manage profiles/add-prof"
              element={<AddProfessional />}
            />
            <Route path="/hr/interview scheduled" element={<Interview />} />
            <Route path="/hr/onboarding" element={<Candidates />} />
            <Route path="/hr/our employees" element={<Employee />} />
            <Route path="/hr/attendance" element={<Attendence />} />
            <Route path="/hr/system user" element={<SystemUser />} />
            <Route
              path="/hr/external professionals"
              element={<ExternalProf />}
            />
            <Route path="/hr/Care Coordinator" element={<CareCoordinator />} />
            <Route path="/hr/gis analytics" element={<Home />} />
            <Route path="hhc/hr/dashboard" element={<HRDashboard />} />
            <Route path="hhc/hr/manage profiles" element={<ManageProfile />} />
            <Route
              path="hhc/hr/manage profiles/add-prof"
              element={<ManageProfile />}
            />
            <Route path="hhc/hr/interview scheduled" element={<Interview />} />
            <Route path="hhc/hr/onboarding" element={<Candidates />} />
            <Route path="hhc/hr/our employees" element={<Employee />} />
            <Route path="hhc/hr/attendance" element={<Attendence />} />
            <Route
              path="hhc/hr/Care Coordinator"
              element={<CareCoordinator />}
            />

            <Route path="hhc/hr/system user" element={<SystemUser />} />

            <Route
              path="hhc/hr/external professionals"
              element={<ExternalProf />}
            />
            <Route path="hhc/gis analytics" element={<Home />} />
            {/* temporary basis */}
            {/* <Route path="/hhc/attendance" element={<DemoPurpose />} /> */}
            {/* <Route path="/hhc/inventory" element={<DemoPurpose />} /> */}
            {/* <Route
              path="/hhc/hcm/manage professional"
              element={<DemoPurpose />}
            /> */}
            <Route path="/hhc/hcm/Long Term Form" element={<LongTearmForm />} />
            {/* <Route path="/hhc/hcm/Long Term Form" element={<LongTearmForm />} /> */}
            {/* <Route
              path="/hhc/hcm/manage system users"
              element={<DemoPurpose />}
            /> */}
            {/* <Route
              path="/hhc/hcm/manage availability"
              element={<DemoPurpose />}
            /> */}
            {/* <Route
              path="/hhc/hcm/manage payments(vip)"
              element={<DemoPurpose />}
            /> */}
            {/* <Route path="/hhc/dashboard/dashboard" element={<DemoPurpose />} /> */}
            {/* <Route
              path="/hhc/accounts/paytm payment"
              element={<DemoPurpose />}
            /> */}
            {/* temporary basis */}
            {/* ATTENDANCE module */}
            {/* <Route path="/attendance/attendance-view" element={<ManageAttendance />} />
            <Route path="/attendance/attendance-dashboard" element={<AtteDashboard />} />
            <Route path="/attendance/attendance-report" element={<ManageReports />} /> */}
            <Route
              path="/hhc/attendance/manage attendance"
              element={<ManageAttendance />}
            />
            <Route
              path="/hhc/attendance/attendance-dashboard"
              element={<AtteDashboard />}
            />
            <Route
              path="/hhc/attendance/manage report"
              element={<ManageReports />}
            />
            <Route
              path="/hhc/attendance/manage attendance"
              element={<ManageAttendance />}
            />
            {/* Management Dashboard */}
            <Route
              path="/management/management-dashboard"
              element={<ManagementDashboard />}
            />
            <Route
              path="hhc/dashboard/management dashboard"
              element={<ManagementDashboard />}
            />
            <Route
              path="hhc/dashboard/financial dashboard"
              element={<MM2Dashboard />}
            />
            {/* clinical governance */}
            {/* <Route exact path="/hhc/clinical" element={<Header />} /> */}
            <Route exact path="/hhc/clinical" element={<Clinicalgov />} />
            {/* <Route path="/hhc/clinical/telemed" element={<Telemedicine />} /> */}
            {/* Inventory module */}
            {/* <Route
              path="/hhc/inventory/manageinventory"
              element={<ManageInventory />}
            /> */}
            {/* <Route path="/hhc/attendance/attendance-dashboard" element={<AtteDashboard />} />
            <Route path="/hhc/attendance/manage report" element={<ManageReports />} /> */}
            <Route path="*" element={<NotFound />} />
            {/* Hospital ROuting */}
            <Route path="/hospital/dashboard" element={<HospitalDashboard />} />
            {/* HR PARTNER */}
            <Route path="/hr partner/dashboard" element={<HrDashboard />} />
            <Route
              path="/hr partner/manage professionals"
              element={<ManageProfessionals />}
            />
            <Route
              path="/hr partner/Add professionals"
              element={<AddProfPartner />}
            />
            <Route
              path="/hr partner/service details"
              element={<Servicedetails />}
            />
            <Route path="hhc/hr partner/dashboard" element={<HrDashboard />} />
            <Route
              path="hhc/hr partner/manage professionals"
              element={<ManageProfessionals />}
            />
            <Route
              path="hhc/hr partner/Add professionals"
              element={<AddProfPartner />}
            />
            <Route
              path="hhc/hr partner/service details"
              element={<Servicedetails />}
            />
            <Route path="/analytics/home" element={<Home />} />
            <Route path="/MM2Dashboard" element={<MM2Dashboard />} />
            <Route path="/hhc/refund" element={<Refund />} />
            {/* Physio */}
            {/* <Route path="/physio" element={<Physio />} /> */}
            <Route exact path="/hhc/ClinicalNew" element={<Clinicalgov />} />
            <Route
              exact
              path="/hhc/clinical governance"
              element={<Clinicalgov />}
            />
            {/* {SupervisorVisitor} */}
            <Route
              path="/hhc/Supervisor Visitor"
              element={<SupervisorVisitor />}
            />
            <Route
              path="/hhc/physio Quality Audit"
              element={<PhysioMiles />}
            ></Route>
            <Route path="/physioMilestone" element={<PhysioMiles />}></Route>
            <Route
              path="/physio Quality Audit"
              element={<PhysioMiles />}
            ></Route>
            <Route path="/AddPhysioMiles" element={<AddPhysioMiles />}></Route>
            {/* <Route path="/long-term-form" element={<MedicalForm />}></Route> */}

            {/* Payment Payout */}
            <Route
              path="/hhc/payment payout/prof request payout"
              element={<ProfRequestPayout />}
            />
            <Route
              path="/hhc/payment payout/process payout"
              element={<ProcessPayout />}
            />
            <Route
              path="/hhc/payment payout/approved payout list"
              element={<ApprovedPayoutList />}
            />
            <Route
              path="/hhc/payment payout/reports"
              element={<PaymentpayoutReport />}
            />

            <Route
              path="/long-term-form"
              element={
                linkExpired === false ? (
                  <>
                    {console.log(
                      " Rendering MedicalForm with eventID:",
                      eventID,
                    )}
                    <MedicalForm eventID={eventID} />
                  </>
                ) : linkExpired === "notFound" ? (
                  <Box
                    sx={{
                      minHeight: "100vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background:
                        "linear-gradient(135deg, rgba(245,247,250,1) 0%, rgba(230,240,245,1) 100%)",
                      px: 2,
                    }}
                  >
                    <Paper
                      elevation={4}
                      sx={{
                        p: { xs: 3, sm: 4 },
                        borderRadius: 3,
                        maxWidth: 400,
                        textAlign: "center",
                      }}
                    >
                      <ErrorOutlineIcon
                        sx={{
                          fontSize: { xs: 60, sm: 80 },
                          color: "error.main",
                          mb: 1,
                        }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          color: "error.main",
                          fontWeight: 600,
                          fontSize: { xs: "16px", sm: "18px" },
                        }}
                      >
                        The requested service does not exist.
                      </Typography>
                    </Paper>
                  </Box>
                ) : linkExpired === "submitted" ? (
                  <Box
                    sx={{
                      minHeight: "100vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background:
                        "linear-gradient(135deg, rgba(245,247,250,1) 0%, rgba(230,240,245,1) 100%)",
                      px: 2,
                    }}
                  >
                    <Paper
                      elevation={4}
                      sx={{
                        p: { xs: 3, sm: 4 },
                        borderRadius: 3,
                        maxWidth: 400,
                        textAlign: "center",
                      }}
                    >
                      <BlockOutlinedIcon
                        sx={{
                          fontSize: { xs: 60, sm: 80 },
                          color: "warning.main",
                          mb: 1,
                        }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          color: "warning.main",
                          fontWeight: 600,
                          fontSize: { xs: "16px", sm: "18px" },
                        }}
                      >
                        The form has already been submitted.
                      </Typography>
                    </Paper>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      minHeight: "100vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background:
                        "linear-gradient(135deg, rgba(245,247,250,1) 0%, rgba(230,240,245,1) 100%)",
                      px: 2,
                    }}
                  >
                    <Paper
                      elevation={4}
                      sx={{
                        p: { xs: 3, sm: 4 },
                        borderRadius: 3,
                        maxWidth: 400,
                        textAlign: "center",
                      }}
                    >
                      <ErrorOutlineIcon
                        sx={{
                          fontSize: { xs: 60, sm: 80 },
                          color: "error.main",
                          mb: 1,
                        }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          color: "error.main",
                          fontWeight: 600,
                          fontSize: { xs: "16px", sm: "18px" },
                        }}
                      >
                        The link has expired. The service has been cancelled.
                      </Typography>
                    </Paper>
                  </Box>
                )
              }
            />
            <Route
              path="/TermsandConditions"
              element={<TermsCondition />}
            ></Route>
            <Route
              path="/CancellationRefundPolicy"
              element={<CancellationRefundPolicy />}
            ></Route>
            <Route path="/ContactInfo" element={<ContactInfo />}></Route>
            <Route path="/About-Us" element={<AboutUs />}></Route>

            <Route
              path="hhc/consultant/referred patient details"
              element={<ReferredPatientDetails />}
            ></Route>
            <Route
              path="hhc/consultant/referred patient"
              element={<ReferredPatient />}
            ></Route>
            <Route
              path="consultant/referred patient details"
              element={<ReferredPatientDetails />}
            ></Route>
            <Route
              path="consultant/referred patient"
              element={<ReferredPatient />}
            ></Route>
            <Route
              path="/hhc/reports/shift-handover"
              element={<ShiftHandoverReport />}
            ></Route>
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
